// extracted by mini-css-extract-plugin
export default {"textSpan":"HeaderFormRight_textSpan__ODmaD","textButton":"HeaderFormRight_textButton__IN3Gf"};